import { useMutation } from '@tanstack/react-query';
import { getPipelineBranchesQuery } from '../apis';

// POST /api/pipelines/{id}/branches (deploy-pipelines-run-overrides, Wave 4, OQ-B). Deliberately
// a `useMutation`, not a `useQuery`: there is no query key, so react-query holds the resolved
// branch list under no cacheable key and no `invalidateQueries` call can ever re-trigger it. The
// caller (PipelineRunForm) is the only place the resolved list is held, in its OWN component
// state — never redux, never storage (OQ-B / AC-24 / NFR-Security) — fetched once per PAT entry,
// on an explicit user action, never on mount.
const useGetPipelineBranches = () => {
	return useMutation({
		mutationFn: getPipelineBranchesQuery
	});
};

export default useGetPipelineBranches;
